// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/servicos/salvar
 *
 * Creates or updates a service (servico).
 * If servico_id is provided, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface Servicos_SalvarInput {
servico_nome: string
servico_id?: number
servico_valor_padrao?: number
servicoscategoria_id?: number
}

registerContract('Servicos_SalvarInput', {
  servico_nome:         { type: 'string',  required: true },
  servico_id:           { type: 'number',  required: false },
  servico_valor_padrao: { type: 'number',  required: false },
  servicoscategoria_id: { type: 'number',  required: false },
})
